import { Component, OnInit } from '@angular/core';
import { Costcenter } from '../costcenter';
import { CostcenterService } from '../costcenter.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-costcenter-list',
  templateUrl: './costcenter-list.component.html',
  styleUrls: ['./costcenter-list.component.css']
})
export class CostcenterListComponent implements OnInit {
  SerchText:string ='';
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  Costcenter = new Costcenter();  //Po is defined from abobe import po
  costcenters: Costcenter[];
  totalrecord:number;
  message: string;	
  costcenterFilter: any = { costcentername: '' };

  constructor(
    private costcenterService: CostcenterService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
  ) { }

  ngOnInit() {
    this.getCostCenters();
  }

  getCostCenters() {
    this.spinnerService.show();
    return this.costcenterService.getCostcenterlist()
               .subscribe(
                costcenters => {
                  console.log(costcenters);
                  this.costcenters = costcenters
          this.totalrecord = this.costcenters.length;
          this.spinnerService.hide();
                 }
                );
 }
 delete(costcenterid): void {
  //this.submitted = true;
  this.costcenterService.deleteCostCenter(costcenterid)
      .subscribe(()=> this.message = "Cost Center Deleted Successfully!");
  this.getCostCenters();   
}


public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}
}
